import type { ProcessDraftStep } from '@bliks-io/contracts';

/**
 * `sourceStepId` / `targetStepId` are both stableStepIds (React Flow node.ids
 * post–Phase 2). `sourceSteps[].stepId` stores stableStepIds natively.
 *
 * Returns an ARBITRARY rep (`ruleIds[0]`) for a merged multi-output entry
 * (`[R_yes, R_no]`), so callers that need to scope a specific decision output
 * must pass the clicked ruleId explicitly rather than rely on this. Today the
 * only caller reaching here without an explicit ruleId is the task-level
 * successor disconnect, where the parent is not a decision (no ruleIds), so the
 * arbitrary-pick is moot.
 */
export function findEdgeRuleId(
  sourceStepId: string,
  targetStepId: string,
  allSteps: ProcessDraftStep[]
): string | undefined {
  const target = allSteps.find((s) => String(s.stableStepId) === targetStepId);
  if (!target) return undefined;
  for (const input of target.inputs ?? []) {
    if (input.inputType !== 'previous_output') continue;
    for (const src of input.sourceSteps ?? []) {
      if (src.stepId === sourceStepId) return src.ruleIds?.[0];
    }
  }
  return undefined;
}
